import { render, staticRenderFns } from "./InfoAzienda.vue?vue&type=template&id=7ba1fa69&"
import script from "./InfoAzienda.vue?vue&type=script&lang=js&"
export * from "./InfoAzienda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports